var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "dropdown multi-select"
  }, [_c('input', {
    ref: "input",
    staticClass: "form-control bg-white pr-5",
    attrs: {
      "data-toggle": "dropdown",
      "placeholder": _vm.placeholder
    },
    on: {
      "click": _vm.focus,
      "keyup": _vm.search
    }
  }), _vm.active ? _c('button', {
    staticClass: "btn icon position-absolute",
    staticStyle: {
      "top": ".1rem",
      "right": ".15rem"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.close($event);
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]) : _vm._e(), _c('div', {
    staticClass: "dropdown-menu flex-column w-100",
    staticStyle: {
      "max-height": "300px"
    },
    on: {
      "click": e => e.stopPropagation()
    }
  }, [_c('div', {
    staticClass: "overflow-auto flex-fill py-2"
  }, [_vm._l(_vm.results, function (item) {
    return _c('a', {
      key: item[_vm.uniqueKey],
      staticClass: "dropdown-item",
      class: {
        'alert-primary': _vm.selectedIndex(item[_vm.uniqueKey]) > -1,
        'disabled': item.disable
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function ($event) {
          return _vm.toggleSelect(item[_vm.uniqueKey], $event);
        }
      }
    }, [_vm._v(_vm._s(item[_vm.displayKey]))]);
  }), _vm.results.length == 0 ? _c('div', {
    staticClass: "p-4 text-muted text-center bg-light"
  }, [_vm._v("No Results Found")]) : _vm._e()], 2), _c('div', {
    staticClass: "border-top row m-0 pt-3 pb-2"
  }, [_c('div', {
    staticClass: "col px-4 text-muted text-nowrap text-truncate text-italic"
  }, [_vm._v("Selected: " + _vm._s(_vm.selected.length))]), _c('div', {
    staticClass: "col text-right px-4 text-nowrap"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        return _vm.selectAll($event);
      }
    }
  }, [_vm._v("Select All")]), _c('span', {
    staticClass: "px-2 text-muted"
  }, [_vm._v("|")]), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        return _vm.clear($event);
      }
    }
  }, [_vm._v("Clear")])])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };